<script setup lang="ts">
import { useRepeatedClickCounter } from './useRepeatedClickCounter';

const props = withDefaults(
  defineProps<{
    count: number;
    showAfterClicks?: number;
  }>(),
  {
    showAfterClicks: 1,
  }
);

const emit = defineEmits<{
  start: [];
  success: [];
}>();

const { clickedCount, isHidden, isSuccess, countScale, handleClick } =
  useRepeatedClickCounter({
    count: () => props.count,
    showAfterClicks: () => props.showAfterClicks,
    onStart: () => emit('start'),
    onSuccess: () => emit('success'),
  });
</script>

<template>
  <div
    class="repeated-click-counter"
    :class="{ 'is-hidden': isHidden, 'is-success': isSuccess }"
    data-testid="repeated-click-counter"
    @click="handleClick"
  >
    <span class="count" :style="{ transform: `scale(${countScale})` }">
      &times;{{ clickedCount }}
    </span>
  </div>
</template>

<style scoped>
.repeated-click-counter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: var(--reset-counter-color, #ffffff);
  cursor: pointer;
  user-select: none;
}

.count {
  font-size: 1.9rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.55);
  pointer-events: none;
  transition:
    transform 140ms ease,
    opacity 140ms ease;
}

.count::first-letter {
  font-size: 68%;
  opacity: 0.65;
}

.is-hidden .count {
  opacity: 0;
  transition: none;
}

.is-success .count {
  color: var(--reset-counter-success-color, #34d399);
  text-shadow: 0 0 0.35em var(--reset-counter-success-color, #34d399);
}
</style>
